"use strict";

exports.__esModule = true;
exports.default = afterFrame;
var RAF_TIMEOUT = 100;

function afterFrame(callback) {
  var handler = function handler() {
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
    setTimeout(callback);
  };

  var timeout = setTimeout(handler, RAF_TIMEOUT);
  var raf = requestAnimationFrame(handler);
}


//////////////////
// WEBPACK FOOTER
// ./~/@elastic/apm-rum-core/dist/lib/common/after-frame.js
// module id = 424
// module chunks = 0